import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Button,
  DateWrapper,
  Warning,
  ErrorMsg,
} from "@onegovbugs/onegov-react-components";
import {
  isCompleted,
  isAFutureDate,
  isDateValid,
  validate,
  scrollToError,
  isDateValidAndPast,
  isDateValidAnd18Yo
} from "../../../utils/Validation";
import styles from "./Project.module.scss";
import { saveApplication, storeProjectDetail } from "../../../redux/actions";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import ScrollToTop from "../../../utils/ScrollToTop";

const ProjectDetail = (props) => {
  RedirectIfCaptchaNotSelected(props);
  ScrollToTop();

  const dispatch = useDispatch();

  const projectDetail = useSelector((state) => state.projectDetail);
  const [title, setTitle] = useState(projectDetail ? projectDetail.title : "");
  const [objective, setObjective] = useState(
    projectDetail ? projectDetail.objective : ""
  );
  const [equipment, setEquipment] = useState(
    projectDetail ? projectDetail.equipment : ""
  );
  const [dayOfProjectEndDate, setDayOfProjectEndDate] = useState(
    projectDetail ? projectDetail.dayOfProjectEndDate : ""
  );
  const [monthOfProjectEndDate, setMonthOfProjectEndDate] = useState(
    projectDetail ? projectDetail.monthOfProjectEndDate : ""
  );
  const [yearOfProjectEndDate, setYearOfProjectEndDate] = useState(
    projectDetail ? projectDetail.yearOfProjectEndDate : ""
  );
  const [isProjectEndDateValid, setIsProjectEndDateValid] = useState(true);
  const [isProjectEndDateRequired, setIsprojectEndDateRequired] = useState(
    true
  );
  const [limitTitleErrorMsg, setTitleCharLimitErrorMsg] = useState("You have 2000 characters left.");
  const [limitObjErrorMsg, setObjCharLimitErrorMsg] = useState("You have 2000 characters left.");
  const [limitEquipErrorMsg, setEquipCharLimitErrorMsg] = useState("You have 2000 characters left.");

  useEffect(() => {
    const maxLength = 2000;
    if (equipment){
      if (equipment.length === maxLength){
        setEquipCharLimitErrorMsg("You have reached the limit");
      }
      else{
        let charLeft = maxLength - equipment.length
        setEquipCharLimitErrorMsg("You have " + charLeft + " characters left.");
      }
    }
    if(objective){
      if (objective.length === maxLength){
        setObjCharLimitErrorMsg("You have reached the limit");
      }
      else{
        let charLeft = maxLength - objective.length
        setObjCharLimitErrorMsg("You have " + charLeft + " characters left.");
      }
    }    
  }, [
    objective,
    equipment
  ]);

  const onKeyUp = (v, fieldName) => {
    const maxLength = 2000;
    let currentLength = v.length;
    if (currentLength >= maxLength) {
      if (fieldName === "Title") {
        setTitleCharLimitErrorMsg("You have reached the limit");
      }
      if (fieldName === "Objective") {
        setObjCharLimitErrorMsg("You have reached the limit");
      }
      if (fieldName === "Equipment") {
        setEquipCharLimitErrorMsg("You have reached the limit");
      }
    } else {
      var charLeft = maxLength - currentLength;
      if (fieldName === "Title") {
        setTitleCharLimitErrorMsg("You have " + charLeft + " characters left.");
      }
      if (fieldName === "Objective") {
        setObjCharLimitErrorMsg("You have " + charLeft + " characters left.");
      }
      if (fieldName === "Equipment") {
        setEquipCharLimitErrorMsg("You have " + charLeft + " characters left.");
      }
      
    }
  };

  // validation
  const [showErrors, setShowErrors] = useState(false);

  const [errors, setErrors] = useState({
    title: false,
    objective: false,
    equipment: false,
    dayOfProjectEndDate: false,
    monthOfProjectEndDate: false,
    yearOfProjectEndDate: false,
    isProjectDateRequired: false,
    isProjectDateValid: false,
    isDateValidAndPast: false,
  });
  const validators = [
    {
      fieldName: "title",
      fieldValue: title,
      isValid: (v) => isCompleted(v),
    },
    {
      fieldName: "objective",
      fieldValue: objective,
      isValid: (v) => isCompleted(v),
    },
    {
      fieldName: "equipment",
      fieldValue: equipment,
      isValid: (v) => isCompleted(v),
    },
    {
      fieldName: "isProjectDateRequired",
      fieldValue: {
        day: dayOfProjectEndDate,
        month: monthOfProjectEndDate,
        year: yearOfProjectEndDate,
      },
      isValid: (v) =>
        dayOfProjectEndDate && monthOfProjectEndDate && yearOfProjectEndDate,
    },
    {
      fieldName: "isProjectDateValid",
      fieldValue: {
        day: dayOfProjectEndDate,
        month: monthOfProjectEndDate,
        year: yearOfProjectEndDate,
      },
      isValid: isDateValid,
    },
    {
      fieldName: "isDateValidAndPast",
      fieldValue: {
        day: dayOfProjectEndDate,
        month: monthOfProjectEndDate,
        year: yearOfProjectEndDate,
      },
      isValid: (v) => isAFutureDate(dayOfProjectEndDate, monthOfProjectEndDate,yearOfProjectEndDate ),
    },
    // {
    //   fieldName: "isProjectFutureDate",
    //   fieldValue: {
    //     day: dayOfProjectEndDate,
    //     month: monthOfProjectEndDate,
    //     year: yearOfProjectEndDate,
    //   },
    //   isValid: (v) =>
    //     isAFutureDate(
    //       dayOfProjectEndDate,
    //       monthOfProjectEndDate,
    //       yearOfProjectEndDate
    //     ),
    // },
  ];
  useEffect(() => {
    validate(validators, setErrors);
  }, [
    title,
    objective,
    equipment,
    dayOfProjectEndDate,
    monthOfProjectEndDate,
    yearOfProjectEndDate,
  ]);
  console.log(
    "required " + errors.isProjectDateRequired + " valid " + errors.isProjectDateValid
  );

  const storeData = (finished) => {
    const projectRecord = {
      title: title,
      objective: objective,
      equipment: equipment,
      dayOfProjectEndDate: dayOfProjectEndDate,
      monthOfProjectEndDate: monthOfProjectEndDate,
      yearOfProjectEndDate: yearOfProjectEndDate,
      finished: finished,
      step : 5
    };
    dispatch(storeProjectDetail(projectRecord));
  };
  
  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={"col-12"}>
          <label htmlFor={"title"}>Title</label>
          <input
            id={"title"}
            className={styles.inputBox}
            value={title}
            onChange={(event) => {
              setTitle(event.target.value);
            }}
            onKeyUp={(event) => {
              onKeyUp(event.target.value, "Title");
            }}
            maxLength="2000"
          />
          {/* <span>{limitTitleErrorMsg}</span> */}
          {errors.title && showErrors ? (
            <ErrorMsg
              type={"error"}
              className={"ErrorMsg_error"}
              description={"Title is required."}
            />
          ) : null}
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-12"}>
          <label htmlFor={"obkective"}>Objectives</label>
        </div>
        <div className={"col-12"}>
          <textarea
            id="objectives"
            value={objective}
            onChange={(event) => {
              setObjective(event.target.value);
            }}
            onKeyUp={(event) => {
              onKeyUp(event.target.value, "Objective");
            }}
            maxLength="2000"
          />
          <span>{limitObjErrorMsg}</span>
          {errors.objective && showErrors ? (
            <ErrorMsg
              type={"error"}
              className={"ErrorMsg_error"}
              description={"Objective is required."}
            />
          ) : null}
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-12"}>
          <label htmlFor={"equipment"}>Proposed Equipment and Method</label>
        </div>
        <div className={"col-12"}>          
          <textarea
            id={"equipment"}
            value={equipment}
            onChange={(event) => {
              setEquipment(event.target.value);
            }}
            onKeyUp={(event) => {
              onKeyUp(event.target.value, "Equipment");
            }}
            maxLength="2000"
          />
          <span>{limitEquipErrorMsg}</span>
          {errors.equipment && showErrors ? (
            <ErrorMsg
              type={"error"}
              className={"ErrorMsg_error"}
              description={"Equipment is required."}
            />
          ) : null}
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-6"}>
          <label htmlFor={"prjectEndDate"}>Project End Date</label>
          <DateWrapper
            setDayOfBirth={setDayOfProjectEndDate}
            setMonthOfBirth={setMonthOfProjectEndDate}
            setYearOfBirth={setYearOfProjectEndDate}
            onValidationChange={setIsProjectEndDateValid}
            onValidationRequired={setIsprojectEndDateRequired}
            day={dayOfProjectEndDate}
            month={monthOfProjectEndDate}
            year={yearOfProjectEndDate}
            autotab
          ></DateWrapper>
          {showErrors ? (
            errors.isProjectDateRequired ? (
              <ErrorMsg
                type={"error"}
                description={"Project End Date is required."}
              />
            ) : errors.isProjectDateValid ? (
              <ErrorMsg
                type={"error"}
                className={"ErrorMsg_error"}
                description={"Project End Date invalid."}
              />
            ) :
           
            errors.isDateValidAndPast ? ( 
              <ErrorMsg
                type={"error"}
                className={"ErrorMsg_error"}
                description={"Project End Date cannot be in past."}
              />
            ) : null
          ) : null}
        </div>
      </div>

      <div className={"row"}>
        <div className={"col-12"}>
          <Warning type={"warning"}>
            <p>
              DPIE may issue a licence with a duration less than requested,
              however, a licensee may seek the renewal of a licence at the end
              of the licence term
            </p>
          </Warning>
        </div>
      </div>

      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            onClick={() => {
              if (validate(validators, setErrors)) {
                storeData(true);
                setShowErrors(false);
                dispatch(
                  saveApplication("step5", () => {
                    props.history.push(`../../flora-fauna/dashboard`);
                  })
                );
              } else {
                setShowErrors(true);
                scrollToError();
              }
            }}
          >
            Continue
          </Button>

          <Button
            secondary
            onClick={() => {
              storeData(false);
              dispatch(
                saveApplication("step5", () => {
                  props.history.push(`../../flora-fauna/dashboard`);
                })
              );
            }}
          >
            Save & exit section
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter((props) => <ProjectDetail {...props} />);
